<template>
  <v-menu v-model="menu" open-on-hover open-on-focus>
    <template v-slot:activator="{ on, attrs }">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="districtsSelected"
        clearable
        chips
        multiple
        deletable-chips
        small-chips
        :items="districtsSelected"
        :loading="districtsLoading"
        :search-input.sync="districtsSearch"
        item-text="name"
        item-value="id"
        :label="noLabel ? '' : label ? label : $t('District.title')"
        return-object
        v-bind="attrs"
        v-on="on"
        @focus="districtsSearch = ''"
      >
        <template v-slot:append>
          <v-icon
            style="height: 24px; width: 24px"
            :color="menu ? 'primary' : ''"
            @click.stop="menu = !menu"
          >
            {{ menu ? "fa-caret-up" : "fa-caret-down" }}
          </v-icon>
        </template>
      </v-autocomplete>
    </template>
    <div style="max-height: 304px">
      <v-sheet>
        <v-treeview
          v-model="districtsSelected"
          :items="districts"
          :search="districtsSearch"
          :filter="districtsFilter"
          selection-type="independent"
          item-text="name"
          item-key="id"
          item-children="districts"
          item-disabled="disabled"
          open-all
          selectable
          selected-color="primary"
          hoverable
          return-object
          @input="selectedMethod()"
        />
      </v-sheet>
    </div>
  </v-menu>
</template>

<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 45px;
}
</style>

<script>
import Districts from "@/api/districts";

export default {
  name: "SearcherDistrictsWithDescendants",

  props: {
    value: Array,
    label: String,
    noLabel: Boolean,
  },

  computed: {
    districtsFilter() {
      return (item, search, textKey) => item[textKey].indexOf(search) > -1;
    },
  },

  created() {
    this.getDistrictsFromAPI();
  },

  data: () => ({
    menu: false,
    districts: [],
    districtsLoading: false,
    districtsSearch: "",
    districtsSelected: [],
    districtsSelectedItems: [],
  }),

  methods: {
    getDistrictsFromAPI() {
      this.districtsLoading = true;
      Districts.tree({ use_user_permision: 1 })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.districts = response.data.districts;
            }
            this.districtsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.districtsLoading = false;
          }.bind(this)
        );
    },
    selectedMethod() {
      if (this.districtsSelectedItems.length == 0) {
        this.districtsSelected.forEach((detail) => {
          this.addChildren(detail);
        });
      } else {
        this.districtsSelected.forEach((detail) => {
          if (
            this.districtsSelectedItems.findIndex(
              (item) => item.id == detail.id
            ) == -1
          ) {
            this.addChildren(detail);
          }
        });
      }
      this.districtsSelectedItems = this.districtsSelected;
    },

    addChildren(obj) {
      if (this.districtsSelected.findIndex((item) => item.id == obj.id) == -1) {
        this.districtsSelected.push(obj);
      }
      if (obj.districts && obj.districts.length) {
        obj.districts.forEach((item) => {
          this.addChildren(item);
        });
      }
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.districtsSelectedItems = this.value ? this.value : [];
        this.districtsSelected = this.value ? this.value : [];
      },
    },
    districtsSelected: {
      handler() {
        this.$emit("input", this.districtsSelected);
      },
    },
  },
};
</script>
